import { useAdvisorAccess } from '../../hooks'
import { LinearProgress } from '../../components'
import { AdvisorDashboard } from '../advisor'
import { FundList } from './fund-list'

/**
 * Conditional index component that renders AdvisorDashboard or FundList
 * based on whether the user is an advisor
 */
export function FundIndex() {
  const { isAdvisor, loading } = useAdvisorAccess()

  if (loading) {
    return <LinearProgress />
  }

  return isAdvisor ? <AdvisorDashboard /> : <FundList />
}
